<template>
  <div class="metrics-class-charts-row">
    <metrics-class-performance-chart
      :data="performanceTrendData"
      :is-loading="isPerformanceTrendLoading"
      :selected-period="selectedPeriod"
      @update:selectedPeriod="$emit('update:selectedPeriod', $event)"
    />
    <metrics-assignment-summary
      :assignments="assignmentSummaryData"
      :is-loading="isLoading"
      :assignment-base-path="assignmentBasePath"
      :assignment-class-map="assignmentClassMap"
    />
  </div>
</template>

<script>
import MetricsClassPerformanceChart from "./metrics_class_performance_chart.vue";
import MetricsAssignmentSummary from "./metrics_assignment_summary.vue";

export default {
  name: "MetricsClassChartsRow",

  components: {
    MetricsClassPerformanceChart,
    MetricsAssignmentSummary,
  },

  props: {
    performanceTrendData: {
      type: Object,
      default: () => ({ labels: [], datasets: [] }),
    },
    assignmentSummaryData: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isPerformanceTrendLoading: {
      type: Boolean,
      default: false,
    },
    selectedPeriod: {
      type: String,
      default: "month",
    },
    assignmentBasePath: {
      type: String,
      default: null,
    },
    assignmentClassMap: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
.metrics-class-charts-row {
  display: flex;
  gap: 16px;
  padding: 0 24px;
  @media (max-width: 1100px) {
    flex-direction: column;
  }
}
</style>
